// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contratos_ArquivoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /contratos/arquivo/:id/:tipo — link temporário (1 h) do PDF assinado ou do certificado. */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contratos_ArquivoResponseDados {
url: string
nome: string
}

export type Contratos_ArquivoResponse = ApiResponse<Contratos_ArquivoResponseDados>;

registerResponseContract('Contratos_ArquivoResponse', {
  url:  { type: 'string',  required: true },
  nome: { type: 'string',  required: true },
})
